import { useState } from "react";
import { useContextoApp } from "@/app/contexto";
import { useApiResource } from "@/hooks/useApiResource";
import type { Aviso, CanalAviso, EstadoAviso } from "@/lib/api";
import { rutaAvisos } from "@/lib/avisos";

/** Bandeja de avisos por mail y push (sólo lectura, sólo admin): los últimos 200, con filtro por estado y canal. */
export function useAvisosTab() {
  const { membresia } = useContextoApp();
  const [estado, setEstado] = useState<EstadoAviso | "todos">("todos");
  const [canal, setCanal] = useState<CanalAviso | "todos">("todos");
  const recurso = useApiResource<Aviso[]>(rutaAvisos(membresia.fideicomiso_id, estado, canal));
  return {
    estado,
    cambiarEstado: (v: string) => setEstado(v as EstadoAviso | "todos"),
    canal,
    cambiarCanal: (v: string) => setCanal(v as CanalAviso | "todos"),
    avisos: recurso.data ?? [],
    cargando: recurso.loading,
    error: recurso.error?.message ?? null,
  };
}
